Controller.$inject = [];

function Controller() {

}

export function HuiDraggableContainer() {
    return {
        restrict: 'EA',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: `
            <div class="hui hui-draggable-container" ng-transclude></div>
        `
    };
}
